import script from "./UsageUnidadProyectTeam.vue?vue&type=script&setup=true&lang=js"
export * from "./UsageUnidadProyectTeam.vue?vue&type=script&setup=true&lang=js"

import "./UsageUnidadProyectTeam.vue?vue&type=style&index=0&id=36f3428a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36f3428a"]])

export default __exports__